import { render, staticRenderFns } from "./ComRegisterForm.vue?vue&type=template&id=772866b8&"
import script from "./ComRegisterForm.vue?vue&type=script&lang=js&"
export * from "./ComRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports